import {
	endpointsMap,
	ILogOptions,
	ILogResponse
} from './ICustomShopperSystem';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperSystem
 */
class CustomShopperSystem extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Sends logs to logCenter
	 * @param {ILogOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ILogResponse} - Status of the request
	 */
	public async log(fetchOptions: ILogOptions, throwOnError?: boolean): Promise<ILogResponse> {
		const response: ILogResponse = await this.callCustomEndpoint<ILogResponse>(
			fetchOptions,
			endpointsMap.LOG
		);

		if (throwOnError && response.error) {
			throw new Error('System Log API error.');
		}

		return response;
	}
}

export default CustomShopperSystem;
